export const FETCH_API = 'FETCH_API';
export const FETCH_API_FULFILLED = 'FETCH_API_FULFILLED';
export const FETCH_API_REJECTED = 'FETCH_API_REJECTED';

// 전시모듈의 getByCodeList API를 통해 받아온 데이터를 스토어에 넣는 액션. (Junsi.js)
export const SET_POINT_BENEFIT_DATA_FROM_JUNSI =
  'SET_POINT_BENEFIT_DATA_FROM_JUNSI';
export const SET_PAY_DISCOUNT_DATA_FROM_JUNSI =
  'SET_PAY_DISCOUNT_DATA_FROM_JUNSI';
export const SET_PROMOTION_BANNER_FROM_JUNSI =
  'SET_PROMOTION_BANNER_FROM_JUNSI';
export const SET_META_CARD_DISCOUNT_DATA_FROM_JUNSI = 
  'SET_META_CARD_DISCOUNT_DATA_FROM_JUNSI';
